module.exports = __webpack_public_path__ + "img/pc-contact-qd.48ad7bb3.webp";